import * as types from '../../app/employer/redux/constants';

export function loginUserPending(userData) {
   return {
      type: types.AUTH_COMPONENT_LOGIN_USER_PENDING,
      payload: {
         data: userData,
      },
   };
}

export function loginUserError(error) {
   return {
      type: types.AUTH_COMPONENT_LOGIN_USER_ERROR,
      payload: {
         error,
      },
   };
}

// this data here contains the JWT token generated by the server.
export function loginUserSuccess(data) {
   return {
      type: types.AUTH_COMPONENT_LOGIN_USER_SUCCESS,
      payload: {
         token: data.token,
      },
   };
}

export const loginUserSuccessPartner = (data = {}) => {
   const { token } = data;

   return ({
      type: types.AUTH_COMPONENT_LOGIN_USER_SUCCESS_PARTNER,
      payload: {
         token,
      },
   });
};

// The partner credential (authorization2) was rejected — the partner session is dead but
// the DE/gateway sessions may still be valid, so this must never trigger a full logout.
export function partnerSessionExpired() {
   return {
      type: types.AUTH_COMPONENT_PARTNER_SESSION_EXPIRED,
      payload: {},
   };
}

export function logoutUserSuccess(message) {
   return {
      type: types.AUTH_COMPONENT_LOGOUT_USER_SUCCESS,
      payload: {
         message,
      },
   };
}

export function userDetailsSuccess(user) {
   return {
      type: types.AUTH_COMPONENT_GET_USER_DETAILS_SUCCESS,
      payload: {
         user,
      },
   };
}

export function userDetailsError(error) {
   return {
      type: types.AUTH_COMPONENT_GET_USER_DETAILS_ERROR,
      payload: {
         error,
      },
   };
}

export function globalGetUserDetailsLoading() {
   return {
      type: types.GLOBAL_COMPONENT_GET_USER_DETAILS_LOADING,
   };
}

export function globalGetUserDetailsError(message) {
   return {
      type: types.GLOBAL_COMPONENT_GET_USER_DETAILS_ERROR,
      payload: {
         message,
      },
   };
}

export function impersonateUserError() {
   return {
      type: types.AUTH_COMPONENT_USER_IMPERSONATION_ERROR,
   };
}

// update logged in user name
export function userNameUpdate(fname, lname) {
   return {
      type: types.AUTH_COMPONENT_UPDATE_USER_NAME,
      payload: {
         fname,
         lname,
      },
   };
}

// update logged in user phone
export function userPhoneUpdate(phone) {
   return {
      type: types.AUTH_COMPONENT_UPDATE_USER_PHONE,
      payload: {
         phone,
      },
   };
}

// update logged in user phone
export function userEmailUpdate(email) {
   return {
      type: types.AUTH_COMPONENT_UPDATE_USER_EMAIL,
      payload: {
         email,
      },
   };
}

export const extractLoggedInUserPartnerDetails = () => ({
   type: types.AUTH_COMPONENT_INIT_LOGIN_USER_PARTNER_DETAILS,
   payload: {},
});

export const setAuthGlobalIsLoading = (isLoading = true) => ({
   type: types.AUTH_GLOBAL_SET_ISLOADING,
   payload: {
      isLoading,
   },
});
